module.exports = __webpack_public_path__ + "media/sod-small.04e2b850.mp4";